<template>
  <div class="product__feature-image">
    <img :src="url" alt="Itinerary image" :class="{ 'product__image-gray': inactive }" />
  </div>
</template>

<script setup>
defineProps({
  inactive: { type: Boolean, default: false },
  url: String,
})
</script>

<style lang="scss" scoped>
.product__feature-image {
  position: relative;
  padding-top: 100%; /* 357 x 201 */
  img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 15px;
  }
}
.product__image-gray {
  filter: grayscale(1);
}
</style>
